import { useState } from "react";

const channels = [
  { key: "wechat", label: "微信", icon: "ri-wechat-line" },
  { key: "weibo", label: "微博", icon: "ri-weibo-line" },
  { key: "link", label: "复制链接", icon: "ri-links-line" },
];

export default function ShareBar() {
  const [toast, setToast] = useState("");

  const handleClick = (label: string) => {
    setToast(`分享功能为演示状态：${label}（未接入真实分享接口）`);
    window.setTimeout(() => setToast(""), 2600);
  };

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <span className="text-sm text-foreground-500 mr-1 flex items-center gap-1">
        <i className="ri-share-line" />
        分享
      </span>
      {channels.map((c) => (
        <button
          key={c.key}
          type="button"
          onClick={() => handleClick(c.label)}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-background-200 bg-background-50 text-foreground-600 text-sm hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className={c.icon} />
          {c.label}
        </button>
      ))}
      {toast && (
        <div className="absolute top-full left-0 mt-3 z-20 bg-secondary-950 text-background-50 text-xs rounded-md px-3 py-2 animate-fade-in">
          {toast}
        </div>
      )}
    </div>
  );
}